(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('socialLoginButton', socialLoginButton);

    socialLoginButton.$inject = ['$translatePartialLoader', '$translate', '$filter', '$timeout', 'SSO_LOGIN_DATA'];

    function socialLoginButton($translatePartialLoader, $translate, $filter, $timeout, SSO_LOGIN_DATA) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider',
                disabled: '=ngDisabled',
                title: '@ngTitle',
                onButtonClick: '&'
            },
            templateUrl: 'app/account/social/social-login-button/social-login-button.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {

            $translate.refresh();

            scope.click = function() {
                scope.onButtonClick()(scope.provider);
            };

            scope.titles = SSO_LOGIN_DATA;

        }

    }
})();
